module.exports = __webpack_public_path__ + "media/images/plumber-111-abb9af3b2c296b3dab2d6abbfda659b8.jpg";